export const toHslValue = (value: number) => (value * 100).toFixed(0)
export const toHslaString = (color?: ColorHsla) => color ? `hsla(${color.h.toFixed(2)},${toHslValue(color.s)}%,${toHslValue(color.l)}%,${color.a !== undefined ? color.a : 1})` : undefined
